define('shared/initializer/form/adapters/PayPalPayment',[
    '../constants',
    '$',
    './Payment',
    './mixins/Returnable',
    './mixins/OfferValidatable',
    'shared/lib/ctor',
    'shared/lib/RSVP',
    'shared/util/hub',
    'shared/util/state',
    'shared/util/state/adapters/form',
    'shared/util/state/adapters/user',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/remote/order/get',
    'shared/lib/console',
    'shared/lib/URI',
    'shared/util/state/adapters/persistent',
    'shared/util/checkout/checkout'
],
function ( 
    constants, 
    $,
    Payment,
    Returnable, 
    OfferValidatable, 
    ctor, 
    RSVP, 
    hub,
    state, 
    formAdapter,
    userAdapter,
    FormDataDispatcher, 
    getOrder, 
    console, 
    URI,
    persistentAdapter,
    checkoutUtil
) {
    'use strict';

    var Ctor = ctor(function() {

        var me = this;
        me.base.apply(me, arguments);

    }).inherit(Payment);

    var p = Ctor.prototype;

    p.doPageLoad = function(){
        var me = this;
        var basePromise = Payment.prototype.doPageLoad.apply(me, arguments);

        return basePromise
        .then(function(){
            if(isReturnedFromPayPal()){
                me.$form.attr('action', me.$form.attr('data-action-finish'));
            }
            else{
                var cancelUrl = removeAndAddParameterToCurrentUrl(constants.PayPalFlow.ReturnFromPayPal, constants.PayPalFlow.CancelFromPayPal);
                var returnUrl = removeAndAddParameterToCurrentUrl(constants.PayPalFlow.CancelFromPayPal, constants.PayPalFlow.ReturnFromPayPal);
                me.$form.find('[name="' + constants.FIELD.PayPalCancelUrl + '"]').val(cancelUrl);
                me.$form.find('[name="' + constants.FIELD.PayPalReturnUrl + '"]').val(returnUrl);
            }
        })
        .then(function(){ return state.adapters.add(persistentAdapter); })
        .then(function(){ return state.get('persistent.payPalPaymentInfo_Token'); })
        .then(function(tokenRecordedObject){
            if(!isReturnedFromPayPal()) {
                return RSVP.resolve();
            }

            var uri = new URI(location.href);
            var query = uri.query( true );
            if(!tokenRecordedObject || !tokenRecordedObject[0] ||  tokenRecordedObject[0].value != query.token){
                console.error('token recorded: "', tokenRecordedObject, '" does not match token passed back: "' + query.token + '"');
                return RSVP.reject();
            }

            var dispatcher = new FormDataDispatcher( me.$form );
            return dispatcher.dispatch(
            {
                items: {
                    'payPalPaymentInfo.Token': {
                        sources: [{
                            type: 'query',
                            key: 'token'
                        }],
                        targets: [{
                            type: 'form',
                            key: constants.FIELD.payPalPaymentInfoToken
                        }]
                    },
                    'payPalPaymentInfo.PayerID': {
                        allowUndefined: true,
                        sources: [{
                            type: 'query',
                            key: 'PayerID'
                        }],
                        targets: [{
                            type: 'form',
                            key: constants.FIELD.payPalPaymentInfoPayerID
                        }]
                    }
                },
                timeout: 1000 * 10
            });
        })
        .then(function(){
            return RSVP.resolve();
        });
    };

    p.doAfterPageLoad = function() {
        var me = this;
        if(isReturnedFromPayPal()) {
            return hub.get(constants.SUBMISSION.HUB_LOAD_FINISHED)
                .then(function(){
                    me.$form.find('[name=PayPalAuthorized]').prop('checked', true);
                    me.$form.submit();
                });
        }
        else {
            return RSVP.resolve();
        }
    };

    function isReturnedFromPayPal(){
        var uri = new URI(location.href);
        var query = uri.query( true );
        return query.hasOwnProperty(constants.PayPalFlow.ReturnFromPayPal);
    }

    function removeAndAddParameterToCurrentUrl(removed, added){
        var url = new URI(location.href);
        var query = url.query(true);
        delete query[removed];
        query[added] = 'true';
        url.query(query);
        return url.toString();
    }

    p.doBeforeRedirect = function( data ){
        console.log('PayPalPayment doBeforeRedirect received data:', data);

        return RSVP.resolve()
            .then(function () {
                var prm;
                if(isReturnedFromPayPal()){
                    if(data.Success && data.Result && data.Result.OrderId){
                        var orderId = data.Result.OrderId;
                        prm = checkoutUtil.handlePaymentSucceeded.call(this, orderId);
                    }
                    else{
                        prm = RSVP.reject('Order id cannot be found');
                    }
                }
                else{
                    prm = RSVP.resolve()
                        .then(function(){
                            if(data && data.Success && data.Result && data.Result.PayPalPaymentPageUrl){
                                return state.adapters.add(persistentAdapter).then(function(){
                                    var expirationDate = new Date();
                                    expirationDate.setHours(expirationDate.getHours() + 12);
                                    return state.push('persistent.payPalPaymentInfo_Token', {value: data.Result.Token, date: {expiration: expirationDate}});
                                })
                                .then(function(){
                                    location.href = data.Result.PayPalPaymentPageUrl;
                                    var err = new Error('redirecting to PayPal');
                                    err.type = 'redirect';
                                    return RSVP.reject(err);
                                });
                            }
                            else{
                                return RSVP.reject('PayPal initialization failed.');
                            }
                        });
                } 
                return prm;
            })
            .then(function () {
                return data;
            });
    };

    return Ctor;
});
